import { PanoramaFlight } from "@nova/protobuf"
import { selectPanoramaImageByFlightId } from "features/entity-caching/images/panorama/selectors"
import { zoomToShowPoint } from "features/map/control/slice"
import store from "integrations/redux/store"

export const zoomToPanorama = (entity: PanoramaFlight) => {
    const image = selectPanoramaImageByFlightId(entity.id)(store.getState())
    if (!image || !image.latitude || !image.longitude) return
    store.dispatch(zoomToShowPoint({ lng: image.longitude, lat: image.latitude, zoomLevel: 14 }))
}

export const shouldHidePanoramaInspectorPanel = (entity: PanoramaFlight) => {
    return entity.images.length <= 0
}
